import __history from '../util/history.json'
import __guest from '../util/guest.json'
/**
 * @returns {{user_id:string,pass_id:string,timestamp:string,description:string,status:string,name:string,created:string,link?:string,pin?:string}[]}
 */
export const
  _history = () => { return __history; }
/**
 * @returns {{guest_id:string,name:string,pin:string,timestamp:string,user_id:string}[]}
 */
export const _guest = () => { return __guest; }
/**
 * @returns {{user_id:string,user_name:string}[]}
 */
export const
  _users = () => {
    return [{
      user_id: "42309127-f038-4a02-a730-d2d3d0446a15",
      user_name: "Cruise",
      sort: "default"
    }];
  }


// WEBPACK FOOTER //
// ./src/util/seed.js